module.exports = __webpack_public_path__ + "img/zj.baf08be1.jpg";